// extracted by mini-css-extract-plugin
export default {"footerContainer":"Footer_footerContainer__HuXLb","footer":"Footer_footer__HPD2n","copyright":"Footer_copyright__I6guM","version":"Footer_version__TMWJV"};